export default class Coupon {
  constructor() {
    this.couponid = "";
    this.couponName = "";
    this.type = Coupon.typeList()[0].id;
    this.limitedProductTypeList = Coupon.limitedProductTypeList()[0].id;
    this.discountRate = 100;
    this.discountAmount = 0;
    this.count = 0;
    this.receiveCount = 0;
    this.usedCount = 0;
    this.minimalAmount = 0;
    this.isEnable = false;
    this.shopids = [];
    this.vendorid = undefined;
    this.startDate = undefined;
    this.expireDate = undefined;
    this.remark = "";
  }
  static typeList() {
    return [
      {
        id: 1,
        name: "一次性抵用券"
      },
      {
        id: 2,
        name: "一次性折扣券"
      }
    ];
  }
  static limitedProductTypeList() {
    return [
      {
        id: 0,
        name: "不限制"
      },
      {
        id: 1,
        name: "洗衣"
      },
      {
        id: 2,
        name: "烘干"
      }
    ];
  }
}
